import {useUploadQueueStore} from "../store/useUploadQueueStore";
import {useImageDB} from "../utils/imageDb.ts";

export async function rehydrateQueueFromDb() {
    try {
        const q = useUploadQueueStore()
        const db = useImageDB('imageDB')
        // Perf note: db.getByUploadState('queued') currently loads full records
        // including blobs for every matching row. That overhead is rooted in
        // imageDb (out of scope here); ideally it would expose a keys-only query.
        const queued = await db.getByUploadState('queued')
        const validQueued = queued.filter((rec: any) => !!(rec?.workingBlob || rec?.originalBlob))
        const brokenQueued = queued.filter((rec: any) => !validQueued.includes(rec))
        if (brokenQueued.length) {
            await Promise.allSettled(
                brokenQueued.map((rec: any) => db.update(String(rec?.id || ''), {
                    upload: {
                        ...((rec?.upload || {}) as any),
                        state: 'failed',
                        phase: 'failed',
                        lastError: 'Lokale Uploaddaten fehlen. Bitte Bild neu hinzufügen.',
                        tries: 99,
                    },
                } as any)),
            )
        }
        q.enqueueMany(validQueued.map(x => x.id))
    } catch (err) {
        // An IndexedDB failure here must not throw unhandled to the caller; degrade
        // gracefully by leaving the queue empty and logging for diagnostics.
        console.warn('[rehydrateQueueFromDb] failed to rehydrate upload queue from IndexedDB', err)
    }
}
